import React, { Component } from "react"
import { Outlet, useNavigate, useLocation } from "react-router-dom"
import { Spine, TopNavigationItem, componentApi } from "@wk/components-react16"
import Header from "./Header"
import Footer from "./Footer"
import "./layout.scss"
import globalRouter from "../../routes/GlobalRouter"
import { Auth, logUserActivity, UserActivity } from "../../services"
export interface LayoutProps {
  navigate: any
  location: any
}

export interface TopNavigation extends TopNavigationItem {
  visible?: boolean;
}

interface LayoutState {
  items?: TopNavigation[]
  isSpineOpen?: boolean
  selectedItem?: string
  expandedItems?: string[]
  spineWidth?: number
  isClassicStyle?: boolean
}

class Layout extends Component<LayoutProps, LayoutState> {
  static displayName = "Layout"
  writeState = componentApi.writeState.bind(this)
  constructor(props: any) {
    super(props)
    this.state = {}
    this.state["items"] = Auth.privilegeItems();
    this.state["isSpineOpen"] = false
    this.state["selectedItem"] = this.state.items ? this.state.items[0].id : '0';
    this.state["expandedItems"] = []
    this.state["spineWidth"] = 272
    this.state["isClassicStyle"] = true
    this.onExpand = this.onExpand.bind(this)
    this.onSelect = this.onSelect.bind(this)
    this.onUserRequest = this.onUserRequest.bind(this)
    this.onWidthChange = this.onWidthChange.bind(this)
    //this.initialize = this.initialize.bind(this)
    //this.initialize();
  }

  readonly state: LayoutState

  onUserRequest(isOpen: any) {
    this.writeState("isSpineOpen", isOpen)
  }

  onSelect(item: any) {
    this.writeState("selectedItem", item.id)
    this.props.navigate(item.href)
    let userActivity: UserActivity = {
      action: 'click',
      page: 'Home',
      viewName: 'LHS Navigation',
      entityName: item.text
    }
    logUserActivity(userActivity);
  }

  getSelected() {
    return this.state.selectedItem
  }

  onExpand(item: any) {
    const currentlyExpanded = this.state.expandedItems
    if (currentlyExpanded?.includes(item.id)) {
      const newExpanded = currentlyExpanded.filter(
        expandedItem => expandedItem !== item.id,
      )
      this.writeState("expandedItems", newExpanded)
    } else {
      const newExpanded = currentlyExpanded?.concat(item.id)
      this.writeState("expandedItems", newExpanded)
    }
  }

  getExpanded() {
    return this.state.expandedItems?.join(", ")
  }

  onWidthChange(newWidth: number) {
    this.writeState("spineWidth", newWidth)
  }

  componentDidMount(): void {
    this.state.items?.forEach((item: any) => {
      if (item.href.includes(this.props.location.pathname)) {
        this.writeState("selectedItem", item.id)
      }
    });
  }

  render() {
    return (
      <main role="main">
        <Header />
        <div className="main-outlet-wrapper">
          <Spine
            controlMode='controlled'
            navigationItems={this.state.items}
            isClassicStyle={this.state.isClassicStyle}
            enableHoverOpen={false}
            expandedItems={this.state.expandedItems}
            selectedItem={this.state.selectedItem}
            isOpen={this.state.isSpineOpen}
            width={this.state.spineWidth}
            onExpandClick={(event: any) => this.onExpand(event)}
            onItemClick={(event: any) => this.onSelect(event)}
            onUserRequest={(event: any) => this.onUserRequest(event)}
          //onWidthChange={(event: any) => this.onWidthChange(event)}
          >
            <div className="p-3">
              <Outlet />
            </div>
          </Spine>
        </div>
        <Footer />
      </main>
    )
  }
}

export function LayoutRouter(props: any) {
  const navigate = useNavigate()
  const location = useLocation();
  globalRouter.navigate = navigate
  globalRouter.location = location
  return <Layout navigate={navigate} location={location} />
}

export default Layout
